<div id="validatePatientPrescriptions" class="card mt-1">
  <h6 class="card-title m-0 px-2 py-1 d-flex">
    <mat-icon>local_pharmacy</mat-icon>
    <div class="ms-1 pt-1">Patient Prescriptions</div>
  </h6>
  <div class="card-body p-1">
    @if (!loading && prescriptions.length > 0) {
      <app-prescription-list [prescriptions]="prescriptions" [small]="true" [dark]="true" [fixedHeader]="true" />
    } @else {
      <div class="m-2">No prescriptions found.</div>
    }
  </div>
</div>
